/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_Overflow_Mode_TitleInputs */

const en_us2_past_overflow_mode_title = /** @type {(inputs: Past_Overflow_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Overflow Mode`)
};

const en_gb2_past_overflow_mode_title = /** @type {(inputs: Past_Overflow_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Spill Mode`)
};

/**
* | output |
* | --- |
* | "Past Overflow Mode" |
*
* @param {Past_Overflow_Mode_TitleInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const past_overflow_mode_title = /** @type {((inputs?: Past_Overflow_Mode_TitleInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_Overflow_Mode_TitleInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_past_overflow_mode_title(inputs)
	return en_us2_past_overflow_mode_title(inputs)
});